import { CalculateFeeRequest } from './calculate-fee-request';
import { PaymentMethodType } from '../../services/hpf-transaction-service';
import { PaymentFeeType } from './payment-fee-type';

export class CalculateFeeRequestBuilder {
	private calculateFeeRequest: CalculateFeeRequest;

	constructor() {
		this.calculateFeeRequest = new CalculateFeeRequest();
	}

	setUserType(userType: string): this {
		this.calculateFeeRequest.userType = userType;
		return this;
	}

	setMerchantKeys(merchantKeys: number[]): this {
		this.calculateFeeRequest.merchantKeys = merchantKeys;
		return this;
	}

	setZipCode(zipCode: string): this {
		this.calculateFeeRequest.zipCode = zipCode;
		return this;
	}

	setPaymentMethodType(paymentMethodType: PaymentMethodType): this {
		this.calculateFeeRequest.paymentMethodType = paymentMethodType;
		return this;
	}

	setAmountUsedToCalculateSurchargeOnIfApplicable(amount: number): this {
		this.calculateFeeRequest.amountUsedToCalculateSurchargeOnIfApplicable = amount;
		return this;
	}

	setCustomerAccountKeys(customerAccountKeys: number[]): this {
		this.calculateFeeRequest.customerAccountKeys = customerAccountKeys;
		return this;
	}

	setPaymentFeeType(feeType?: PaymentFeeType): this {
		this.calculateFeeRequest.paymentFeeType = feeType ?? PaymentFeeType.SingleOrSingleFuturePayment;
		return this;
	}

	getCalculateFeeRequest(): CalculateFeeRequest {
		return this.calculateFeeRequest;
	}
}
